import {container} from "../services/container";
import {Server} from "../services/server";

export enum UserLevel
{
    vip = 'vip',
    clubcard = 'clubcard'
}

export enum UserAge
{
    underage = '13-17',
    legal = '18-20',
    mature = '21-'
}

export enum UserGender
{
    woman = '1',
    man = '2',
    none = '3'
}

export enum UserLanguage
{
    none = 'none',
    hungarian = 'hu',
    chinese = 'zh',
    vietnamese = 'vi',
    korean = 'ko',
    japanese = 'ja',
    mongolian = 'mn',
    thai = 'th',
    other = 'other'
}

export class Image
{
    filename: string;
    original?: string;
}

export enum UserRole
{
    ROLE_ADMIN = 'ROLE_ADMIN',
    ROLE_USER = 'ROLE_USER'
}

export class User
{
    public id?: number|'new';
    public name?: string;
    public age?: UserAge;
    public gender?: UserGender;
    public email?: string;
    public picture?: Image;
    public isBanned?: boolean;
    public fbProfileLink?: string;
    public birthday?: string;
    public city?: string;
    public level?: UserLevel;
    public idCardPictures?: Image[];
    public nfcCode?: string;
    public barCode?: string;
    public omonaCode?: string;
    public oxcCode?: string;
    public parentingAgreement?: Image;
    public languages?: UserLanguage[];
    public contract?: Image;
    public scanId?: string;
    public willBeDeleted?: boolean;
    public roles: UserRole[];

    public constructor(data: Partial<User>)
    {
        this.id = data.id;
        this.name = data.name || '';
        this.age = data.age;
        this.gender = data.gender || UserGender.none;
        this.languages = data.languages || [UserLanguage.none];
        this.email = data.email || '';
        this.picture = data.picture;
        this.isBanned = data.isBanned;
        this.fbProfileLink = data.fbProfileLink;
        this.birthday = data.birthday || '';
        this.city = data.city || '';
        this.level = data.level || UserLevel.vip;
        this.idCardPictures = data.idCardPictures || [];
        this.nfcCode = data.nfcCode || '';
        this.barCode = data.barCode || '';
        this.omonaCode = data.omonaCode || '';
        this.parentingAgreement = data.parentingAgreement;
        this.contract = data.contract;
        this.scanId = data.scanId || '';
        this.oxcCode = data.oxcCode || '';
        this.roles = data.roles || [UserRole.ROLE_USER];
    }
}

type UserListener = (user: User | null) => void;

let lastRetrievedUser : User | null = null;
const userListeners: UserListener[] = [];

export async function getCurrentUser(refresh: boolean = false) {
    if (!refresh && lastRetrievedUser) {
        return lastRetrievedUser;
    }

    const user = await container.get(Server).get(User, 'users/me').catch(error => {
        console.error("users/me error", error);
        return Promise.resolve(null);
    });

    lastRetrievedUser = user;

    for (const listener of userListeners) {
        listener(user);
    }

    return user;
}

export function addUserListener(newListener: UserListener) {
    userListeners.push(newListener);
}

export function removeUserListener(listener: UserListener) {
    const foundIndex = userListeners.indexOf(listener);
    if (-1 < foundIndex) {
        userListeners.splice(foundIndex, 1);
    }
}

export async function updateUserEmail(newEmail: string) {
    await container.get(Server).post('users/update-email', { newEmail }).catch(error => {
        console.error("users/update-email error", error);
        return Promise.reject(error);
    });
}

export async function userLogout() {
    await container.get(Server).post('logout', {}).catch(error => {
        console.error("logout error", error);
        return Promise.reject(error);
    });

    location.href = "/jegyfoglalas";
}